module.exports = __webpack_public_path__ + "img/ilustracija.74c92f08.svg";